<template>
  <v-card v-if="candidate != null">
    <v-card-title class="headline grey lighten-2">
      Reports of {{ candidate.object }}
    </v-card-title>
    <table-reports :reports="reports"></table-reports>
    <v-card-actions class="headline grey lighten-2">
      <div class="flex-grow-1"></div>
      <v-btn color="primary" text @click="closeDialog">Close</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { formatReports } from "@/components/utils/report.js";
import TableReports from "@/components/tables/TableReports.vue";
export default {
  name: "ReportDetail",
  props: ["candidate", "show"],
  data() {
    return {
      reports: [],
      loading: true
    };
  },
  components: {
    TableReports
  },
  mounted() {
    this.getReports(this.candidate.object);
  },
  methods: {
    getReports(object_id) {
      this.loading = true;
      this.reports = [];
      this.$api.getObjectsReports(object_id).then(response => {
        this.reports = formatReports(response.data.results);
        this.loading = false;
      });
    },
    closeDialog() {
      this.reports = [];
      this.$emit("update:show", false);
    }
  },
  watch: {
    candidate(value) {
      this.getReports(value.object);
    }
  }
};
</script>
